import { jsx as s, jsxs as f } from "react/jsx-runtime";
import { QUERIES as L } from "@fcamna/shared-component-foundations";
import { c as m } from "./index-65016bfa.mjs";
import n, { css as u } from "styled-components";
import { createContext as $, useContext as S, createElement as g } from "react";
import { u as k } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import { c as B } from "./cloneSlots-333ddef1.mjs";
import { u as M } from "./useMediaQuery-2533ee8a.mjs";
import { b as N } from "./useSlots-a1aa6a84.mjs";
import { Icon as v } from "./icon.js";
import { Link as p } from "./link.js";
import "./_commonjsHelpers-92157f1b.mjs";
import "@fcamna/shared-icons";
import "./Aria-f5e019e2.mjs";
const I = $({
  size: "small"
}), y = n.li`
  &.Breadcrumb__list-item {
    ${({
  theme: {
    components: { breadcrumb: e }
  }
}) => u(e.BreadcrumbItem)};
  }
`, x = n.span`
  &.Breadcrumb__list-separator {
    ${({
  theme: {
    components: { breadcrumb: e }
  }
}) => u(e.Separator)};
  }
`, C = ({ children: e, isCurrentPage: l, dataTestId: d, lastItem: i, ...c }) => {
  const { size: r = "small" } = S(I), b = N(e, { link: p }), _ = B(
    b.link,
    (t, a) => i ? /* @__PURE__ */ s("span", { children: t.children }) : /* @__PURE__ */ g(
      p,
      {
        ...t,
        key: a,
        isCurrentPage: t.isCurrentPage ?? l,
        className: m(["Breadcrumb__list-item__link", `Breadcrumb__list-item__link--${r}`, t.className]),
        size: r
      }
    )
  );
  return /* @__PURE__ */ f(
    y,
    {
      "data-testid": d,
      ...c,
      className: m(["Breadcrumb__list-item", c.className]),
      children: [
        _,
        /* @__PURE__ */ s(x, { className: m(["Breadcrumb__list-separator", `Breadcrumb__list-separator--${r}`]), children: "/" })
      ]
    }
  );
};
C.Link = p;
const h = n.ul`
  &.Breadcrumb__list {
    ${({
  theme: {
    components: { breadcrumb: e }
  }
}) => u(e.BreadcrumbList)};
  }
`, E = n.a`
  &.Breadcrumb__list-caret-icon--left {
    ${({
  theme: {
    components: { breadcrumb: e }
  }
}) => u(e.MobileCaretLeftIcon)};
  }
`, o = ({ children: e, size: l = "small", firstChildLink: d, dataTestId: i, ...c }) => {
  const r = N(e, { items: o.Item }), b = k({ label: "Bread Crumbs" }), _ = M(L.mobile);
  return /* @__PURE__ */ s(I.Provider, { value: { size: l }, children: /* @__PURE__ */ s(
    "nav",
    {
      "aria-label": "breadcrumbs",
      ...b,
      ...c,
      className: m(["Breadcrumb", c.className]),
      children: _ ? /* @__PURE__ */ f(
        h,
        {
          "data-testid": i,
          className: "Breadcrumb__list",
          children: [
            /* @__PURE__ */ s(
              E,
              {
                className: "Breadcrumb__list-caret-icon--left",
                href: d,
                "aria-label": "mobile-chevron",
                children: /* @__PURE__ */ s(
                  v,
                  {
                    name: "caretLeft",
                    size: "m"
                  }
                )
              }
            ),
            B(r.items[0], (t, a) => /* @__PURE__ */ s(
              o.Item,
              {
                ...t,
                className: m([t.className, "Breadcrumb__list-item--last"])
              },
              a
            ))
          ]
        }
      ) : /* @__PURE__ */ s(
        h,
        {
          "data-testid": i,
          className: "Breadcrumb__list",
          children: B(r.items, (t, a) => /* @__PURE__ */ s(
            o.Item,
            {
              ...t,
              lastItem: a === r.items.length - 1,
              className: m([
                t.className,
                { "Breadcrumb__list-item--last": a === r.items.length - 1 },
                { [`Breadcrumb__list-item--last--${l}`]: a === r.items.length - 1 }
              ])
            },
            a
          ))
        }
      )
    }
  ) });
};
o.Item = C;
export {
  o as Breadcrumb,
  C as BreadcrumbItem
};
